import { useState, useEffect } from "react";
import { Box, Typography, Tooltip, IconButton } from "@mui/material";
import { rsProgress } from "../../../../RecoilStates";
import { useRecoilState } from "recoil";
import { UseFooterLists } from "./UseFooterLists";
import { useNavigate, useLocation } from "react-router-dom";
import CustomPagination from "../../../../components/CustomPagination";
import { DataGrid, faIR } from "@mui/x-data-grid";
import DeleteIcon from "@mui/icons-material/Delete";
import EditIcon from "@mui/icons-material/Edit";
import DeleteRow from "../../../../components/DeleteRow";
import ArrowDropDownIcon from "@mui/icons-material/ArrowDropDown";
import ArrowDropUpIcon from "@mui/icons-material/ArrowDropUp";
import { readFromLS } from "../../../../util/LocalStrogeService";

export default function ListItems(props) {
  const location = useLocation();
  const navigate = useNavigate();
  const [progress, setProgress] = useRecoilState(rsProgress);
  const { GetFooterList, RemoveFooterListItems, SetFooterListItems } =
    UseFooterLists();
  const [listItemID, setListItemID] = useState(
    props.listId ? props.listId : ""
  );
  const [itemsRes, setItemsRes] = useState([]);
  const [deleteState, setDeleteState] = useState({
    show: false,
    name: undefined,
    id: undefined,
  });
  const [homePageId, setHomePageId] = useState(
    readFromLS("homePage") ? readFromLS("homePage") : undefined
  );
  useEffect(() => {
    if (props.listId) {
      setListItemID(props.listId);
    }
  }, [props.listId]);

  useEffect(() => {
    if (location.state?.listId) {
      setListItemID(location.state?.listId);
    }
  }, [location.state]);

  useEffect(() => {
    if (listItemID) {
      GetFooterList(homePageId?.id ? homePageId.id : 1, (Lists) => {
        let model = Lists.find((model) => model.id == listItemID)?.items;
        setItemsRes(model);
      });
    }
  }, [listItemID]);

  const newFunc = () => {
    return navigate("/footerManage/editList/addItem", {
      state: {
        rows: itemsRes ? itemsRes : [],
        expanded: props.expanded,
        listId: listItemID,
        model: props.items,
        expanded: props.expanded,
      },
    });
  };

  const columns = [
    {
      field: "id",
      width: 80,
      align: "center",
      headerName: "ID",
      headerAlign: "center",
      hide: true,
    },
    {
      field: "rowIndex",
      width: 100,
      align: "center",
      headerName: "اولویت",
      headerAlign: "center",
    },
    {
      field: "title",
      width: 350,
      align: "center",
      headerName: "عنوان",
      headerAlign: "center",
      renderCell: (cellValues) => {
        return (
          <Typography
            variant="span"
            sx={{
              whiteSpace: "nowrap",
              overflow: "hidden",
              textOverflow: "ellipsis",
            }}
          >
            {cellValues.row.title}
          </Typography>
        );
      },
    },
    {
      field: "عملیات",
      sortable: false,
      width: 160,
      headerAlign: "center",
      align: "center",
      headerName: "عملیات",
      renderCell: (cellValues) => {
        return (
          <>
            <Tooltip title="ویرایش">
              <IconButton
                onClick={() => {
                  navigate("/footerManage/editList/editItem", {
                    state: {
                      row: cellValues.row,
                      expanded: props.expanded,
                      listId: listItemID,
                      model: props.items,
                      expanded: props.expanded,
                    },
                  });
                }}
              >
                <EditIcon fontSize="small" sx={{ color: "MyColor.main" }} />
              </IconButton>
            </Tooltip>
            <Tooltip title="حذف">
              <IconButton
                onClick={() => {
                  setDeleteState({
                    show: true,
                    id: cellValues.row.id,
                    name: cellValues.row.title,
                  });
                }}
              >
                <DeleteIcon fontSize="small" sx={{ color: "MyColor.main" }} />
              </IconButton>
            </Tooltip>
            <IconButton
              sx={{ p: 0.5, mr: 0.5 }}
              onClick={() => {
                let model = {
                  id: cellValues.row.id,
                  rowIndex: cellValues.row.rowIndex - 1,
                };
                if (cellValues.row.rowIndex - 1 == 0) {
                  return;
                } else {
                  SetFooterListItems(model, "", () => {
                    GetFooterList(
                      homePageId?.id ? homePageId.id : 1,
                      (Lists) => {
                        let model = Lists.find(
                          (model) => model.id == listItemID
                        ).items;
                        setItemsRes(model);
                      }
                    );
                  });
                }
              }}
            >
              <ArrowDropUpIcon fontSize="small" sx={{}} />
            </IconButton>
            <IconButton
              sx={{ p: 0.5 }}
              onClick={() => {
                let model = {
                  id: cellValues.row.id,
                  rowIndex: cellValues.row.rowIndex + 1,
                };

                if (cellValues.row.rowIndex + 1 == itemsRes?.length + 1) {
                  return;
                } else {
                  SetFooterListItems(model, "", () => {
                    GetFooterList(
                      homePageId?.id ? homePageId.id : 1,
                      (Lists) => {
                        let model = Lists.find(
                          (model) => model.id == listItemID
                        ).items;
                        setItemsRes(model);
                      }
                    );
                  });
                }
              }}
            >
              <ArrowDropDownIcon fontSize="small" sx={{}} />
            </IconButton>
          </>
        );
      },
    },
  ];

  return (
    <Box>
      <Box sx={{ height: "30rem" }}>
        <DataGrid
          className="ltr-grid"
          localeText={faIR.components.MuiDataGrid.defaultProps.localeText}
          columns={columns}
          pageSize={100}
          rows={itemsRes ? itemsRes : []}
          rowCount={itemsRes?.length ? itemsRes.length : 1}
          enableRangeSelection={true}
          disableColumnMenu
          hideFooterSelectedRowCount
          components={{
            Pagination: CustomPagination,
          }}
          componentsProps={{
            pagination: {
              newFunc: newFunc,
              rowCount: itemsRes?.length ? itemsRes.length : "",
            },
          }}
        />
      </Box>
      <DeleteRow
        deleteState={deleteState}
        setDeleteState={setDeleteState}
        type={"آیتم"}
        callback={() => {
          setProgress(true);
          RemoveFooterListItems(deleteState.id, () => {
            GetFooterList(homePageId?.id ? homePageId.id : 1, (Lists) => {
              let model = Lists.find((model) => model.id == listItemID).items;
              setItemsRes(model);
            });
          });
        }}
      ></DeleteRow>
    </Box>
  );
}
